"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Close = function Close(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 22"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.619 11l8.203-9.778a.249.249 0 00-.19-.41h-2.495a.51.51 0 00-.384.179L9.988 9.056 3.222.991a.5.5 0 00-.384-.178H.344a.249.249 0 00-.19.409L8.355 11 .153 20.778a.249.249 0 00.19.41h2.495a.51.51 0 00.384-.179l6.766-8.065 6.765 8.065a.5.5 0 00.384.178h2.494a.249.249 0 00.19-.409L11.62 11z",
    fill: "currentColor"
  }));
};

var _default = Close;
exports.default = _default;